function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React from 'react';
import { useSelector } from 'react-redux';
import { FormattedMessage } from 'react-intl';
import useStyles from 'isomorphic-style-loader/useStyles';
import cn from 'classnames';
import AvatarIcon from 'svg/avatar.svg';
import Account from 'modules/Account';
import messages from '../../../../messages';
import styles from './UserBox.pcss';
const UserBox = ()=>{
    const account = useSelector(Account.selectors.account);
    if (!account) {
        return null;
    }
    const { username, scope } = account;
    const [usernameShortName] = username.split('@');
    useStyles(styles);
    return /*#__PURE__*/ _jsx("div", {
        className: "col-auto",
        children: /*#__PURE__*/ _jsxs("div", {
            className: "d-flex mt-7",
            title: username,
            children: [
                /*#__PURE__*/ _jsx("div", {
                    className: "pr-3",
                    children: /*#__PURE__*/ _jsx(AvatarIcon, {})
                }),
                /*#__PURE__*/ _jsxs("div", {
                    className: "pl-3",
                    children: [
                        /*#__PURE__*/ _jsx("p", {
                            className: cn(styles.userBox__email, 'text--large text--light mb-2'),
                            children: usernameShortName
                        }),
                        /*#__PURE__*/ _jsx("p", {
                            className: "text--normal text--small text--disabled",
                            children: /*#__PURE__*/ _jsx(FormattedMessage, _object_spread({}, messages.sidebarHeader.scope[scope]))
                        })
                    ]
                })
            ]
        })
    });
};
export default UserBox;
